import { Grid, MultiSelect } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import prettifiedLabel from '../../../constants/labelPrettifier';
import useFetch from '../../../helpers/useFetch';
import ErrorMessage from '../../ErrorMessage';
import Spinner from '../../Spinner';

const ConversionBasedAudience = ({ segment, updateSegment, readOnly }) => {
  const [actions, setActions] = useState();
  const [error, setError] = useState();
  const fetch = useFetch();

  const { accountId, domainId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/google/actions`)
      .then(({ actions }) => setActions(actions))
      .catch(setError);
  }, [fetch, accountId, domainId]);

  const handleSelect = (selectedActions) => {
    updateSegment((prev) => {
      return {
        ...prev,
        rules: selectedActions.map((value) => ({ value })),
      };
    });
  };

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (!segment || !actions) {
    return <Spinner />;
  }

  const options = actions.map((action) => {
    return {
      label: `${prettifiedLabel(action.name.toLowerCase())} (Category: ${prettifiedLabel(
        action.category.toLowerCase()
      )})`,
      value: action.resourceName,
    };
  });

  return (
    <>
      <Grid>
        <Grid.Col span={12}>
          <MultiSelect
            name="actions"
            placeholder="Actions"
            data={options}
            value={segment.rules.map((r) => r.value)}
            onChange={handleSelect}
            disabled={readOnly}
          />
        </Grid.Col>
      </Grid>
    </>
  );
};

export default ConversionBasedAudience;
